<div
  id="scrollDiv"
  scrollY="true"
  class="scrollHeight"
  (scroll)="
    storeInfo &&
    storeInfo.design_settings &&
    storeInfo.design_settings.showOnlySelectedCategoryProducts
      ? checkComponentScroll()
      : checkCategoryScrollDebounce()
  "
  *ngIf="categories && groupApp"
>
  <ion-list>
    <app-previous-orders-slider
      *ngIf="
        ((currentUser && hyperCategories && hyperCategories.length === 0) ||
          (currentUser &&
            hyperCategories &&
            hyperCategories.length &&
            currentHyperCategory === hyperCategories[0].hyper_category_id)) &&
        currentUser &&
        !currentUser.only_dinein &&
        !currentUser.only_visitor
      "
    ></app-previous-orders-slider>
    <app-favorites-browser
      [mobileMode]="false"
      *ngIf="
        storeInfo &&
        !storeInfo.showOnlyFavoritesCatalog &&
        !storeInfo.hideFavoritesFromCatalog &&
        ((currentUser && hyperCategories && hyperCategories.length === 0) ||
          (currentUser &&
            hyperCategories &&
            hyperCategories.length &&
            currentHyperCategory === hyperCategories[0].hyper_category_id)) &&
        currentUser &&
        !currentUser.only_dinein &&
        !currentUser.only_visitor
      "
    ></app-favorites-browser>
    <span
      *ngFor="
        let category of categories
          | filterSelectedCategoryProducts : selectedCategoryId : storeInfo
          | filterEmptyCategoriesForOnlyDineInDeliveryPickupProducts
            : orderPickup
            : dineIn;
        trackBy: categoriesTrackFn
      "
    >
      <app-product-market-type-cards-category-browser
        *ngIf="
          category.activeTotal &&
          !category.emptyCategoryForSelectedDeliveryMethod &&
          !category.cardsDesign &&
          !category.sliderDesign &&
          category.marketCardsDesign
        "
        id="{{ 'category_' + category.category_id }}"
        [category_id]="category.category_id"
        [groupStoreData]="groupStoreData"
        [selectedDineInTable]="selectedDineInTable"
        [selectedPreorderDate]="selectedPreorderDate"
        [cartProductIds]="cartProductIds"
        [scrollFromBottom]="scrollFromBottom"
        (showNextCategoryButtonEvent)="showNextCategoryButtonEv($event)"
      >
      </app-product-market-type-cards-category-browser>
      <app-product-items-cards-category
        *ngIf="
          category.activeTotal &&
          !category.emptyCategoryForSelectedDeliveryMethod &&
          category.cardsDesign &&
          !category.sliderDesign &&
          !category.marketCardsDesign
        "
        id="{{ 'category_' + category.category_id }}"
        [category_id]="category.category_id"
        [groupStoreData]="groupStoreData"
        [selectedDineInTable]="selectedDineInTable"
        [selectedPreorderDate]="selectedPreorderDate"
      >
      </app-product-items-cards-category>
      <app-product-items-popular-category
        *ngIf="
          category.activeTotal &&
          !category.emptyCategoryForSelectedDeliveryMethod &&
          category.sliderDesign &&
          !category.sliderDesignOnlyImage &&
          !category.cardsDesign &&
          !category.marketCardsDesign
        "
        id="{{ 'category_' + category.category_id }}"
        [category_id]="category.category_id"
        [groupStoreData]="groupStoreData"
        [selectedDineInTable]="selectedDineInTable"
        [selectedPreorderDate]="selectedPreorderDate"
      >
      </app-product-items-popular-category>

      <app-product-items-popular-category-only-image
        *ngIf="
          category.activeTotal &&
          category.sliderDesign &&
          !category.emptyCategoryForSelectedDeliveryMethod &&
          category.sliderDesignOnlyImage &&
          !category.cardsDesign &&
          !category.marketCardsDesign
        "
        id="{{ 'category_' + category.category_id }}"
        [category_id]="category.category_id"
        [groupStoreData]="groupStoreData"
        [selectedDineInTable]="selectedDineInTable"
        [selectedPreorderDate]="selectedPreorderDate"
      >
      </app-product-items-popular-category-only-image>
      <app-category-item
        *ngIf="
          category.activeTotal &&
          !category.sliderDesign &&
          !category.cardsDesign &&
          !category.marketCardsDesign
        "
        id="{{ 'category_' + category.category_id }}"
        [category_id]="category.category_id"
        [groupStoreData]="groupStoreData"
      >
      </app-category-item>
      <app-subcategory-products-browser
        *ngIf="
          category.subCategoriesActive &&
          category.subCategories &&
          !category.emptyCategoryForSelectedDeliveryMethod &&
          category.subCategories.length &&
          !category.sliderDesign &&
          !category.cardsDesign &&
          !category.marketCardsDesign
        "
        [category_id]="category.category_id"
        [unavailableProductsByCategoryId]="unavailableProductsByCategoryId"
        [changedUnavailableProductsByCategoryIdTimestamp]="
          changedUnavailableProductsByCategoryIdTimestamp
        "
        [scrollFromBottom]="scrollFromBottom"
      >
      </app-subcategory-products-browser>

      <app-browser-product-list-products
        [category_id]="category.category_id"
        [category]="category"
        [storeInfo]="storeInfo"
        [forceTwoColumnProducts]="forceTwoColumnProducts"
        [cartProductIds]="cartProductIds"
        [groupStoreData]="groupStoreData"
        [selectedDineInTable]="selectedDineInTable"
        [selectedPreorderDate]="selectedPreorderDate"
        [dineIn]="dineIn"
        [orderPickup]="orderPickup"
        [webp]="webp"
        [scrollFromBottom]="scrollFromBottom"
        [hyperCategories]="hyperCategoriesForProductItem"
        (showNextCategoryButton)="showNextCategoryButtonEv($event)"
      >
      </app-browser-product-list-products>

      <ion-grid
        style="width: 100%"
        *ngIf="
          storeInfo &&
          !storeInfo.showAllUnavailableProducts &&
          unavailableProductsByCategoryId &&
          category &&
          !category.emptyCategoryForSelectedDeliveryMethod &&
          category.products &&
          unavailableProductsByCategoryId[category.category_id] &&
          unavailableProductsByCategoryId[category.category_id].length &&
          !category.sliderDesign &&
          (!(
            storeInfo &&
            storeInfo.design_settings &&
            storeInfo.design_settings.showOnlySelectedCategoryProducts
          ) ||
            showNextCategoryButton)
        "
        class="ion-text-center"
      >
        <ion-button
          class="unavailableMinHeight"
          (click)="openUnavailableProductsModal(category)"
          button="true"
          lines="none"
          fill="clear"
          size="small"
        >
          <ion-label class="ion-text-center ion-no-margin">
            {{
              unavailableProductsByCategoryId[category.category_id].length <
              category.products.length
                ? "+"
                : ""
            }}{{ unavailableProductsByCategoryId[category.category_id].length }}
            {{ "unavailable-products" | translate }}
          </ion-label>
        </ion-button>
      </ion-grid>

      <ion-grid
        style="width: 100%"
        *ngIf="
          category &&
          category.emptyCategoryForSelectedDeliveryMethod &&
          (!(
            storeInfo &&
            storeInfo.design_settings &&
            storeInfo.design_settings.showOnlySelectedCategoryProducts
          ) ||
            showNextCategoryButton)
        "
        class="ion-text-center"
      >
        <ion-item lines="none">
          <ion-label class="ion-text-wrap ion-text-center">
            <ion-text
              color="danger"
              *ngIf="orderPickup == false && dineIn == false"
              >{{
                "catalog.categories.there-are-no-products-in-this-category-for-delivery"
                  | translate
              }}
            </ion-text>
            <ion-text
              color="danger"
              *ngIf="orderPickup == true && dineIn == false"
              >{{
                "catalog.categories.there-are-no-products-in-this-category-for-takeaway"
                  | translate
              }}
            </ion-text>
            <ion-text
              color="danger"
              *ngIf="orderPickup == false && dineIn == true"
              >{{
                "catalog.categories.there-are-no-products-in-this-category-for-dinein"
                  | translate
              }}
            </ion-text>
          </ion-label>
        </ion-item>
      </ion-grid>
    </span>
    <app-next-hyper-category
      *ngIf="
        hyperCategories &&
        hyperCategories &&
        hyperCategories.length > 1 &&
        (!(
          storeInfo &&
          storeInfo.design_settings &&
          storeInfo.design_settings.showOnlySelectedCategoryProducts
        ) ||
          showNextCategoryButton)
      "
    ></app-next-hyper-category>

    <div
      *ngIf="atLeastOneFrozenTag"
      style="
        margin-top: 20px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
      class="ion-text-center"
    >
      <ion-icon
        style="font-size: 14px; margin-right: 5px"
        color="primary"
        src="assets/flatIcons/frozen.svg"
      ></ion-icon>
      <ion-text style="font-size: small; font-weight: 500">
        {{ "item-tags.frozen" | translate }}
      </ion-text>
    </div>

    <app-catalog-disclaimer-button> </app-catalog-disclaimer-button>
  </ion-list>
</div>
